export default __webpack_public_path__ + "static/media/SCIFIPANEL11V2HUSK.743c45b0.png";